<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryShipmentResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-redo"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="查看/调整装车"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="reload()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-truck"
                                        :disabled="actionDisabled('select')"
                                        custom-label="发货"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="confirmLoad()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-export"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="生成主箱单"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="generateMasterPackingList()"
                                    >
                                    </em-button>
                                    <!-- <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-export"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="生成ASN"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="generateAsn()"
                                    >
                                    </em-button> -->
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="调整包装箱" :visible.sync="reloadDialogVisible" :close-on-click-modal='false' append-to-body @close='clearReloadForm'>
            <el-table :data="loadedPackages" ref="loadedPackages" style="width:100%" max-height="285px">
                <!-- <el-table-column type="selection" width="30"></el-table-column> -->
                <el-table-column label="箱号" fixed prop="boxNo"></el-table-column>
                <el-table-column label="包装编码" prop="packageNo"></el-table-column>
                <el-table-column label="类型" prop="packageType">
                    <template slot-scope="scope">
                        {{packageTypeName(scope.row.packageType)}}
                    </template>
                </el-table-column>
                <el-table-column label="内容描述" prop="description"></el-table-column>
                <el-table-column label="长/mm" prop="length"></el-table-column>
                <el-table-column label="宽/mm" prop="width"></el-table-column>
                <el-table-column label="高/mm" prop="height"></el-table-column>
                <el-table-column label="净重/kg" prop="netWeight"></el-table-column>
                <el-table-column label="毛重/kg" prop="roughWeight"></el-table-column>
                <el-table-column fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 子对话框，选择已包装好的包装箱 -->
            <el-dialog title="选择包装箱" :center="true" append-to-body :visible.sync="childDialogVisible"
                       :close-on-click-modal='false' @close='closeChildDialog'>
                <el-row>
                    <el-col :span="20">
                        <el-form :model="filterForm" :inline=true label-position="left">
                            <el-form-item label="包装箱描述">
                                <el-input v-model="filterForm.filterString"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="1">
                        <el-button type="info" icon="el-icon-search" @click="findPackagesByDescription">搜索</el-button>
                    </el-col>
                </el-row>
                <el-table :data="packedPackages" ref="addPackageTable" style="width:100%" max-height="285px" @selection-change="handleChildChange">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="箱号" prop="boxNo"></el-table-column>
                    <el-table-column label="包装编码" prop="packageNo"></el-table-column>
                    <el-table-column label="类型" prop="packageType">
                        <template slot-scope="scope">
                            {{packageTypeName(scope.row.packageType)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="描述" prop="description"></el-table-column>
                    <el-table-column label="长/mm" prop="length"></el-table-column>
                    <el-table-column label="宽/mm" prop="width"></el-table-column>
                    <el-table-column label="高/mm" prop="height"></el-table-column>
                    <el-table-column label="净重/kg" prop="netWeight"></el-table-column>
                    <el-table-column label="毛重/kg" prop="roughWeight"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="childDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmSelection()">确认</el-button>
                </div>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="openAddPackageDialog()">添加</el-button>
                <el-button @click="reloadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="reloadPackages()">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="发货" :visible.sync="loadDialogVisible" :close-on-click-modal='false' append-to-body @close='clearLoadForm'>
            <el-form :model="loadForm" ref="loadForm" label-width="auto" size="mini" :inline="true">
                <el-form-item label="运输方">
                    <el-input v-model="loadForm.transporter" ></el-input>
                </el-form-item>
                <el-form-item label="运输方式">
                    <el-input v-model="loadForm.transportType" ></el-input>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-input v-model="loadForm.licensePlate" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="loadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="load()" :disabled="checkLoadForm">确认发货</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-25 11:48:21

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesInventoryShipmentListView",
        mixins: [emCommonListMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                loadDialogVisible: false,
                loadForm:{
                    transporter:'',
                    transportType: '',
                    licensePlate: '',
                },
                reloadDialogVisible: false,
                childDialogVisible: false,
                filterForm: {
                    filterString: ''
                },
                //已经装车的包装箱
                loadedPackages:[],
                //根据描述搜索出的，已经包装且未装车的包装箱
                packedPackages:[],
                //选择要添加的包装箱
                selectedPackages: [],
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"].join(",");
            },
            checkLoadForm() {
                let obj = this.loadForm;
                for(const key in obj) {
                    if(obj[key] === null || obj[key] === '') {
                        return true;
                    }
                }
                return false;
            },
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            confirmLoad() {
                this.loadDialogVisible = true;
            },
            clearLoadForm() {
                this.loadForm.transporter = '';
                this.loadForm.transportType = '';
                this.loadForm.licensePlate = '';
            },
            load() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryShipment")}/load?ids=${this.selectIds}&transporter=${this.loadForm.transporter}&transportType=${this.loadForm.transportType}&licensePlate=${this.loadForm.licensePlate}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "发货成功",
                            type: "success",
                            });

                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "发货失败",
                            type: "error",
                            });
                        }
                    }).finally(() => {
                        this.loadDialogVisible = false;
                    })
            },
            reload() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/findPackagesByShipmentId?id=${self.checkedItems}`
                self.$_emApiMixin_post(url, {})
                .then(response => {
                    self.loadedPackages = response.data;
                    this.reloadDialogVisible = true;
                })
            },
            clearReloadForm() {
                this.loadedPackages = [];
            },
            closeChildDialog() {
                this.filterForm.filterString = '';
                this.packedPackages = [];
                this.selectedPackages = [];
            },
            openAddPackageDialog() {
                this.childDialogVisible = true;
            },
            findPackagesByDescription() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/findPackagesByDescription?description=${self.filterForm.filterString}`
                self.$_emApiMixin_post(url, {})
                .then(response => {
                    self.packedPackages = response.data;
                })
            },
            handleChildChange(val) {
                this.selectedPackages = val;
            },
            confirmSelection() {
                this.childDialogVisible = false;
                for(let i=0,length=this.selectedPackages.length;i<length;i++) {
                    if(this.loadedPackages.findIndex(x => x.id === this.selectedPackages[i].id) === -1) {
                        this.loadedPackages.push(this.selectedPackages[i]);
                    }
                }
            },
            //删除已装车的包装箱
            handleDelete(index, row) {
                this.loadedPackages.splice(index,1);
            },
            //更新发货任务,存在并发时如何处理？
            reloadPackages() {
                console.log(this.loadedPackages);
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/reloadPackages?shipmentId=${this.selectIds}`;
                this.$_emApiMixin_post(url, self.loadedPackages)
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "调整成功",
                            type: "success",
                            });
                        } else {
                            self.$message({
                            message: "调整失败",
                            type: "error",
                            });
                        }
                    }).finally(() => {
                        this.reloadDialogVisible = false;
                    })

            },
            // 将箱类型整数转为对应的类型名
            packageTypeName(type) {
                if(type) {
                    switch(type) {
                        case 1:
                            return '内箱'
                        case 2:
                            return '外箱'
                    }
                }
            },
            generateMasterPackingList() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generateMasterPackingList?shipmentId=${this.selectIds}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "正在生成主箱单",
                            type: "success",
                            });
                        } else {
                            self.$message({
                            message: "生成主箱单失败",
                            type: "error",
                            });
                        }
                    })
            },
            generateAsn() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generateAsn?shipmentId=${this.selectIds}`;
                this.$_emApiMixin_post(url, {})
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "正在生成ASN",
                            type: "success",
                            });
                        } else {
                            self.$message({
                            message: "生成ASN失败",
                            type: "error",
                            });
                        }
                    })
            }

        },
        mounted() {
            this.$refs.emListFilter.doQuery();

        }
    };
</script>
